import React, { useState, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Navbar from "../components/Navbar";
import { ToastContainer, toast } from "react-toastify"; // Make sure to import Toastify
import "react-toastify/dist/ReactToastify.css"; // Ensure the CSS for Toastify is imported
import axios from "axios";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Footer from "./Footer";
import Fitur from "./Fitur";
import DeleteIcon from "../assets/delete.png";
import apiClient from "../components/apiClient";
import ClickPickup from "../assets/Click & Pickup crop.png";
import FreeShipping from "../assets/Free Shipping crop.png";
import SameDayDelivery from "../assets/Some Day Delivery crop.png";
import Clock from "../assets/Clock.png";

const Cart = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedCartItems, setSelectedCartItems] = useState(null);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [isMixedCart, setIsMixedCart] = useState(false);

  const location = useLocation();

  const ProductModal = ({ product, onClose }) => {
    if (!product) return null;

    console.log(product); // Log to check product structure

    // Destructure product to avoid accessing deep properties repeatedly
    const { Produk } = product;
    const { nama_produk, image, deskripsi, spesifikasi, harga } = Produk;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000]">
        <div className="bg-white p-6 rounded-lg max-w-xl w-full relative max-h-[80vh] overflow-y-auto">
          <button
            onClick={onClose}
            className="absolute top-2 right-2 text-black bg-transparent text-xl font-bold cursor-pointer z-[2000]"
          >
            X
          </button>

          <h2 className="text-xl font-semibold mb-4">{nama_produk}</h2>

          <img src={image[0]} alt={nama_produk} className="w-full mb-4" />

          {deskripsi && (
            <p className="mb-4">
              <strong>Description:</strong> {deskripsi}
            </p>
          )}

          {spesifikasi && (
            <p className="mb-4">
              <strong>Specification:</strong> {spesifikasi}
            </p>
          )}

          <div className="text-xl font-bold mb-2">
            <strong>Price:</strong> {formatRupiah(harga)}
          </div>
        </div>
      </div>
    );
  };

  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    modal: {
      backgroundColor: "white",
      padding: "20px",
      borderRadius: "8px",
      maxWidth: "600px",
      width: "100%",
      position: "relative", // Ensure close button positions correctly
      maxHeight: "80vh", // Limit modal height
      overflowY: "auto", // Allow scrolling in the content area if it overflows
    },
    closeButton: {
      position: "absolute",
      top: "10px",
      right: "10px",
      border: "none",
      color: "black",
      backgroundColor: "transparent",
      fontSize: "20px",
      cursor: "pointer",
      zIndex: 2000, // Ensure button stays above other elements
    },
  };

  const { id } = useParams(); // Get the id from URL params
  const { nama_produk } = useParams(); // Get the id from URL params
  const [product, setProduct] = useState(null); // Define the state and setter here

  const [products, setProducts] = useState([]);
  const [brands, setBrands] = useState([]);

  // const handleImageClick = (id) => {
  const handleImageClick = (nama_brand, id) => {
    localStorage.setItem("brandId", id);
    localStorage.setItem("brandNama", nama_brand);

    // navigate(`/detail-brand/${id}`);
    navigate(`/all-brand/${nama_brand}`);
  };

  // const handleCardClick = (id) => {
  const handleCardClick = (nama_produk) => {
    // navigate(`/produk/all/${id}`);
    navigate(`/all-produk/${nama_produk}`); // Redirect ke URL produ
  };

  // Fetch data dari API
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_BASE_URL}/brand`)
      .then((response) => response.json())
      .then((data) => {
        console.log(data); // Check the received data
        setBrands(data);
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  // useEffect(() => {
  //   const fetchProductDetails = async () => {
  //     try {
  //       const response = await apiClient.get(`/produk/all/${id}`);
  //       if (response.status === 200) {
  //         setProduct(response.data);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching product details:", error);
  //     }
  //   };

  //   fetchProductDetails();
  // }, [id]);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await apiClient.get("/produk/all");
        if (response.status === 200) {
          setProducts(response.data);
        }
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchProducts();
  }, []);

  const responsive = {
    desktop: { breakpoint: { max: 3000, min: 1024 }, items: 4 },
    tablet: { breakpoint: { max: 1024, min: 464 }, items: 2 },
    mobile: { breakpoint: { max: 464, min: 0 }, items: 1 },
  };

  const [cart, setCart] = useState([]); // Cart items state
  const [selectedItems, setSelectedItems] = useState([]); // Selected items for checkout
  const navigate = useNavigate();

  useEffect(() => {
    const fetchCartData = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        localStorage.removeItem("selectedCartItems");
        localStorage.removeItem("selectedItems");
        setSelectedItems([]);
        navigate("/login");
        return;
      }

      try {
        const cartResponse = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/cart`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (cartResponse.status === 401) {
          localStorage.removeItem("selectedCartItems");
          localStorage.removeItem("selectedItems");
          setSelectedItems([]);
          toast.error("Session expired. Please log in again.", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          navigate("/login");
          return;
        }

        const cartData = await cartResponse.json();
        if (cartData.cartItems) {
          setCart(cartData.cartItems);

          // ✅ Save to localStorage
          localStorage.setItem(
            "selectedCartItems",
            JSON.stringify(
              cartData.cartItems.map((item) => ({
                ...item,
                harga_per_item:
                  parseFloat(item.subtotal) / Number(item.jumlah || 1),
                subtotal: parseFloat(item.subtotal),
                jumlah: Number(item.jumlah),
              }))
            )
          );
        } else {
          setCart([]);
          localStorage.setItem("selectedCartItems", JSON.stringify([]));
        }
      } catch (error) {
        console.error("Failed to fetch cart data", error);
        setCart([]);
        localStorage.setItem("selectedCartItems", JSON.stringify([]));
      }
    };

    fetchCartData();
  }, [navigate]);

  const handleSelectItem = (productId) => {
    setSelectedItems((prev) => {
      const updatedSelectedItems = prev.includes(productId)
        ? prev.filter((id) => id !== productId)
        : [...prev, productId];

      localStorage.setItem(
        "selectedItems",
        JSON.stringify(updatedSelectedItems)
      );

      // ✅ Check preorder vs ready-stock
      const selectedItemsDetail = cart.filter((item) =>
        updatedSelectedItems.includes(item.id)
      );

      const statuses = selectedItemsDetail.map(
        (item) => (item.produk || item.Produk || {}).preorder
      );

      const hasPreorder = statuses.includes("Y");
      const hasReadystock = statuses.includes("N");

      setIsMixedCart(hasPreorder && hasReadystock);

      console.log(updatedSelectedItems);
      return updatedSelectedItems;
    });
  };

  useEffect(() => {
    const storedItems = localStorage.getItem("selectedCartItems");
    if (storedItems) {
      const parsedItems = JSON.parse(storedItems).map((item) => {
        const jumlah = Number(item.jumlah) || 1;

        // Try to derive harga_per_item from `item.harga_per_item` or from Produk.harga[]
        let harga = Number(item.harga_per_item);
        if (!harga || harga === 0) {
          const hargaArray =
            item.produk?.harga || item.Produk?.harga || item.harga || [];
          harga = Array.isArray(hargaArray)
            ? Number(hargaArray[0]) || 0
            : Number(hargaArray) || 0;
        }

        return {
          ...item,
          jumlah,
          harga_per_item: harga,
          subtotal: jumlah * harga,
        };
      });
      setSelectedCartItems(parsedItems);
    }
  }, []);

  const handleRemoveItem = async (productId) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/cart/${productId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`, // Pastikan token disertakan
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to delete item");
      }

      const storedCart = JSON.parse(localStorage.getItem("cart")) || [];
      const updatedStoredCart = storedCart.filter(
        (item) => item.id !== productId
      );
      localStorage.setItem("cart", JSON.stringify(updatedStoredCart));

      const updatedCart = cart.filter((item) => item.id !== productId);
      setCart(updatedCart);
      setSelectedItems((prev) => prev.filter((id) => id !== productId));

      toast.success("Item berhasil dihapus!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });

      setTimeout(() => {}, 1000);
    } catch (error) {
      console.error("Error deleting item:", error);

      toast.error("Gagal menghapus item dari keranjang.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  const handleChangeQuantity = async (cartItemId, quantity) => {
    try {
      if (quantity <= 0) return;

      const updatedCart = cart.map((item) =>
        item.id === cartItemId ? { ...item, jumlah: Number(quantity) } : item
      );
      setCart(updatedCart);

      const storedSelected =
        JSON.parse(localStorage.getItem("selectedCartItems")) || [];

      const updatedSelected = storedSelected.map((item) => {
        const harga =
          Number(item.harga_per_item) ||
          Number(item.produk?.harga?.[0]) ||
          Number(item.Produk?.harga?.[0]) ||
          0;

        return item.id === cartItemId
          ? {
              ...item,
              jumlah: Number(quantity),
              harga_per_item: harga,
              subtotal: Number(quantity) * harga,
            }
          : item;
      });

      localStorage.setItem(
        "selectedCartItems",
        JSON.stringify(updatedSelected)
      );

      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/cart/${cartItemId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify({ jumlah: Number(quantity) }),
        }
      );

      if (!response.ok) {
        console.error("Failed to update cart item");
        setCart(cart); // rollback
        localStorage.setItem(
          "selectedCartItems",
          JSON.stringify(storedSelected)
        ); // rollback
      }
    } catch (error) {
      console.error("Error updating quantity:", error);
      setCart(cart);
    }
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedItems(cart.map((item) => item.id));
    } else {
      setSelectedItems([]);
    }
  };

  console.log(localStorage.getItem("userId"));

  const handleCheckout = async () => {
    localStorage.removeItem("selectedOption");
    localStorage.removeItem("selectedCourier");

    if (selectedItems.length === 0) {
      toast(
        "Please select at least one item or select all items before proceeding to checkout.",
        {
          type: "warning",
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        }
      );
      return;
    }

    const selectedCartItems = cart
      .filter((item) => selectedItems.includes(item.id))
      .map((item) => {
        const produk = item.produk || item.Produk || {};
        const hargaArray = produk.harga || [];
        const hargaPerItem = Number(hargaArray[0]) || 0;
        const jumlah = Number(item.jumlah) || 0;
        const subtotal = jumlah * hargaPerItem;

        return {
          id: item.id,
          produkId: item.produkId,
          jumlah,
          subtotal,
          colorName: item.colorName,
          color_hex: item.color_hex,
          preorder: produk.preorder,
          produk: {
            nama_produk: produk.nama_produk,
            harga: produk.harga,
            image: produk.image,
            diskon: produk.diskon,
            spesifikasi: produk.spesifikasi,
            berat: produk.berat,
            keterangan: produk.keterangan,
            brand: produk.brand,
            kodepromo: produk.kodepromo,
          },
        };
      });

    // Check if mixed preorder status exists
    const preorderStatuses = selectedCartItems.map((item) => item.preorder);
    const hasPreorder = preorderStatuses.includes("Y");
    const hasReadyStock = preorderStatuses.includes("N");

    if (hasPreorder && hasReadyStock) {
      // 👇 Show warning in the UI
      setSnackbarMessage(
        "⚠️ Order Contains Mixed Status Items. You cannot check out with both pre-order and ready-stock products in the same order. To continue, please remove one type and place a separate order."
      );
      setOpenSnackbar(true);
      return;
    }

    localStorage.setItem(
      "selectedCartItems",
      JSON.stringify(selectedCartItems)
    );

    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
      return;
    }

    const userId = localStorage.getItem("userId");
    if (!userId) {
      toast("User ID not found, please log in again.", {
        type: "error",
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return;
    }

    const payload = {
      userId,
      cartId: selectedItems[0], // Only sending one cartId here
    };

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/selected`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error("Failed to send selected items to the server");
      }

      navigate("/checkout");
    } catch (error) {
      console.error("Error during checkout:", error);
      toast("Failed to proceed with checkout. Please try again later.", {
        type: "error",
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  // useEffect(() => {
  //   const savedItems = JSON.parse(
  //     localStorage.getItem("selectedCartItems") || "[]"
  //   );

  //   const updated = savedItems.map((item) => {
  //     let harga = 0;
  //     try {
  //       if (item.Produk?.harga) {
  //         harga = Number(JSON.parse(item.subtotal)[0]) || 0;
  //       } else if (item.produk?.harga) {
  //         harga = Number(JSON.parse(item.subtotal)[0]) || 0;
  //       }
  //     } catch (e) {
  //       console.error("Failed to parse harga:", e);
  //     }

  //     return {
  //       ...item,
  //       subtotal: (item.jumlah || 1) * harga,
  //     };
  //   });

  //   setCart(updated);
  // }, []);

  const cartItems = cart || [];
  const selectedCart = cartItems.filter((item) =>
    selectedItems.includes(item.id)
  );

  const formatRupiah = (angka) => {
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
    }).format(angka);
  };

  const subtotalAfterDiscount = selectedCart.reduce((total, item) => {
    const produk = item.produk || item.Produk || {};
    const hargaArray = produk.harga || [];
    const basePrice = Number(hargaArray[0]) || 0;
    const quantity = Number(item.jumlah) || 0;
    const discountPercentage = Number(produk.diskon) || 0;

    const priceAfterDiscount =
      discountPercentage > 0
        ? basePrice - (basePrice * discountPercentage) / 100
        : basePrice;

    const itemTotal = priceAfterDiscount * quantity;

    return total + itemTotal;
  }, 0);

  const calculateTotal = (selectedCart) => {
    return selectedCart.reduce((total, item) => {
      const product = item.Produk;

      if (product && product.harga && product.diskon !== undefined) {
        const price = parseFloat(product.harga) || 0;
        const discountPercentage = parseFloat(product.diskon) || 0;
        const quantity = parseInt(item.jumlah, 10) || 0;

        const priceAfterDiscount =
          discountPercentage > 0
            ? price - (price * discountPercentage) / 100
            : price;

        return total + priceAfterDiscount * quantity;
      }

      return total;
    }, 0);
  };

  const totalPrice = calculateTotal(selectedCart);

  const subtotal = selectedCart.reduce((total, item) => {
    const price = localStorage.getItem("selectedPrice") || 0;
    const produk = item.produk || item.Produk || {};
    const hargaArray = produk.harga || [];
    const basePrice = Number(hargaArray[0]) || 0;
    console.log(price);

    const quantity = parseInt(item.jumlah, 10) || 0;
    return total + basePrice * quantity;
  }, 0);

  console.log(subtotal);

  const totalDiscount = selectedCart.reduce((total, item) => {
    const discount = parseFloat(item.Produk.diskon) || 0;
    return total + discount;
  }, 0);

  const color = selectedCart.reduce((accumulator, item) => {
    if (item.colorName) {
      accumulator.push(item.colorName);
    }
    return accumulator;
  }, []);

  const warna = [
    ...new Set(
      cartItems
        .filter((item) => selectedItems.includes(item.id))
        .map((item) => item.colorName?.trim().toLowerCase())
        .filter(Boolean)
    ),
  ].map((color) => color.charAt(0).toUpperCase() + color.slice(1));

  const totalAfterDiscount = subtotalAfterDiscount;
  console.log(totalAfterDiscount);
  const isSelectAllChecked = selectedItems.length === cart.length;

  const [hoveredProductId, setHoveredProductId] = useState(null);

  const openModal = (productId) => {
    apiClient
      .get(`/produk/${productId}`)
      .then((response) => {
        setProduct(response.data);
        setIsModalOpen(true);
      })
      .catch((error) => {
        console.error("Error fetching product details:", error);
      });
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setProduct(null);
  };

  const handleDetailClick = (item) => {
    setSelectedProduct(item);
    setIsModalOpen(true);
  };

  const totalWeight = cart
    .filter((item) => selectedItems.includes(item.id))

    .reduce((acc, item) => {
      console.log(item.jumlah);
      return acc + item.Produk.berat * item.jumlah;
    }, 0);

  return (
    <div>
      <Navbar />
      <ToastContainer />

      {/* <div className="mt-40 px-4 md:px-8"> */}
      <div className="px-4 md:px-8">
        <h1 className="text-center text-3xl md:text-5xl font-extrabold">
          CART <span className="text-gray-500">({cart.length})</span>
        </h1>

        <div className="text-left my-4 flex items-center gap-3">
          <label className="relative inline-block">
            <input
              type="checkbox"
              checked={isSelectAllChecked}
              onChange={handleSelectAll}
              disabled={cart.length === 0}
              className={`w-6 h-6 md:w-8 md:h-8 border-2 rounded ${
                isSelectAllChecked ? "bg-black" : "bg-white"
              } ${cart.length === 0 ? "cursor-not-allowed opacity-50" : ""}`}
            />
          </label>
          <label
            className={`text-lg md:text-2xl font-medium ${
              cart.length === 0 ? "text-gray-400" : ""
            }`}
          >
            Select All
          </label>
        </div>

        {cart.length === 0 ? (
          <p className="text-center">Keranjang Anda kosong!</p>
        ) : (
          <div className="flex flex-col lg:flex-row gap-6">
            <div className="flex-1 space-y-5">
              {cart.map((item) => {
                const produk = item.produk || item.Produk || {};
                const brand = produk.brand || {};
                let images = produk.image || [];
                try {
                  if (typeof images === "string") images = JSON.parse(images);
                } catch (e) {
                  console.error("Error parsing images:", e);
                  images = [];
                }
                const firstImage =
                  images.length > 0 ? images[0] : "/placeholder.png";
                const jumlah = Number(item.jumlah) || 1;
                // const subtotal = Number(item.subtotal) || 0;
                // const hargaPerItem =
                //   Number(item.harga_per_item) ||
                //   (Number(item.subtotal) && Number(item.jumlah)
                //     ? Number(item.subtotal) / Number(item.jumlah)
                //     : 0);
                const hargaArray = produk.harga || [];
                const hargaPerItem = Number(hargaArray[0]) || 0;
                const subtotal = jumlah * hargaPerItem;

                const discountedSubtotal = produk.diskon
                  ? Math.floor(subtotal - (subtotal * produk.diskon) / 100)
                  : subtotal;

                return (
                  // <div
                  //   key={item.id}
                  //   className="flex flex-col md:flex-row items-start bg-white shadow-lg rounded-lg"
                  // >
                  //   <div className="flex flex-row gap-4 w-full">
                  //     <div className="relative">
                  //       <input
                  //         type="checkbox"
                  //         checked={selectedItems.includes(item.id)}
                  //         onChange={() => handleSelectItem(item.id)}
                  //         className={`absolute top-2 left-2 w-6 h-6 md:w-8 md:h-8 border-2 rounded ${
                  //           selectedItems.includes(item.id)
                  //             ? "bg-black"
                  //             : "bg-white"
                  //         } appearance-none cursor-pointer`}
                  //       />
                  //       {selectedItems.includes(item.id) && (
                  //         <span className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-white font-bold text-sm md:text-base"></span>
                  //       )}
                  //       <img
                  //         src={firstImage}
                  //         alt={produk.nama_produk}
                  //         className="w-24 h-24 md:w-32 md:h-32 object-cover rounded-lg ml-10 md:ml-14"
                  //       />
                  //     </div>

                  //     <div className="flex flex-col md:flex-col justify-between flex-1 px-2 md:px-5">
                  //       <h4 className="flex-1 px-5 text-sm md:text-lg font-bold">
                  //         {brand.nama_brand} {produk.nama_produk}
                  //       </h4>

                  //       <p className="flex-1 px-5 text-sm md:text-lg text-gray-500">
                  //          Color: {item.colorName}
                  //       </p>
                  //     </div>

                  //     <div className="p-2 flex flex-col md:flex-col justify-between">
                  //       <div className="flex items-center space-x-2 text-xs md:text-lg font-bold">
                  //         {produk.diskon ? (
                  //           <>
                  //             {formatRupiah(discountedSubtotal)}
                  //             <span className="block text-xs md:text-sm text-gray-400 line-through">
                  //               {formatRupiah(subtotal)}
                  //             </span>
                  //           </>
                  //         ) : (
                  //           formatRupiah(subtotal)
                  //         )}
                  //       </div>

                  //       <div className="flex items-center space-x-2 text-base md:text-lg mb-4">
                  //         <img
                  //           src={DeleteIcon}
                  //           alt="Hapus"
                  //           className="w-6 h-6 md:w-8 md:h-8 cursor-pointer"
                  //           onClick={() => handleRemoveItem(item.id)}
                  //         />
                  //         <button
                  //           onClick={() =>
                  //             handleChangeQuantity(item.id, jumlah - 1)
                  //           }
                  //           disabled={jumlah <= 1}
                  //           className="bg-black text-white w-8 h-8 flex items-center justify-center rounded hover:bg-gray-400 hover:text-black"
                  //         >
                  //           -
                  //         </button>
                  //         <span className="text-lg font-bold">{jumlah}</span>
                  //         <button
                  //           onClick={() =>
                  //             handleChangeQuantity(item.id, jumlah + 1)
                  //           }
                  //           className="bg-black text-white w-8 h-8 flex items-center justify-center rounded hover:bg-gray-400 hover:text-black"
                  //         >
                  //           +
                  //         </button>
                  //       </div>
                  //     </div>
                  //   </div>
                  // </div>

                  <div
                    key={item.id}
                    className="flex flex-col md:flex-row items-start bg-white shadow-lg rounded-lg p-4"
                  >
                    <div className="flex flex-row md:flex-row gap-4 w-full">
                      {/* Left: Checkbox + Image */}
                      <div className="relative flex-shrink-0">
                        <input
                          type="checkbox"
                          checked={selectedItems.includes(item.id)}
                          onChange={() => handleSelectItem(item.id)}
                          className={`absolute top-2 left-2 w-6 h-6 md:w-8 md:h-8 border-2 rounded ${
                            selectedItems.includes(item.id)
                              ? "bg-black"
                              : "bg-white"
                          } appearance-none cursor-pointer`}
                        />
                        <img
                          src={firstImage}
                          alt={produk.nama_produk}
                          className="w-24 h-24 md:w-32 md:h-32 object-cover rounded-lg ml-10 md:ml-14"
                        />
                      </div>

                      {/* Right: Content stack for mobile, row for desktop */}
                      <div className="flex flex-col md:flex-row justify-between w-full px-2 md:px-5">
                        {/* Info Section */}
                        <div className="flex flex-col mb-2 md:mb-0">
                          <h4 className="text-sm md:text-lg font-bold">
                            {brand.nama_brand} {produk.nama_produk}
                          </h4>
                          <p className="text-sm md:text-lg text-gray-500">
                            Color: {item.colorName}
                          </p>

                          {produk.preorder === "Y" && (
                            <div className="relative w-full text-start">
                              <div className="bg-white text-[#CCAB5C] py-1 font-semibold text-base md:text-lg flex items-center gap-2">
                                <img
                                  src={Clock}
                                  alt="Clock icon"
                                  className="h-6 w-6"
                                />{" "}
                                Pre-Order
                              </div>
                            </div>
                          )}
                        </div>

                        {/* Price and Actions */}
                        <div className="flex flex-col items-start md:items-end justify-between">
                          {/* Price */}
                          <div className="flex flex-col items-center space-x-2 text-sm md:text-lg font-bold">
                            {/* {produk.diskon ? (
                              <>
                                {formatRupiah(discountedSubtotal)}
                                <span className="text-xs md:text-sm text-gray-400 line-through block w-ful">
                                  &nbsp;{formatRupiah(subtotal)}
                                </span>
                              </>
                            ) : (
                              formatRupiah(subtotal)
                            )} */}
                            {produk.harga &&
                            (produk.harga[0] || produk.harga) ? (
                              Number(produk.diskon) > 0 ? (
                                <>
                                  <span className="text-red-500 font-bold text-sm md:text-lg">
                                    {formatRupiah(
                                      (produk.harga[0] || produk.harga) -
                                        ((produk.harga[0] || produk.harga) *
                                          Number(produk.diskon)) /
                                          100
                                    ).replace("Rp", "Rp ")}
                                  </span>
                                  <span className="text-gray-400 line-through text-sm">
                                    {formatRupiah(
                                      produk.harga[0] || produk.harga
                                    ).replace("Rp", "Rp ")}
                                  </span>
                                </>
                              ) : (
                                <span className="text-sm md:text-lg font-medium text-gray-700">
                                  {formatRupiah(
                                    produk.harga[0] || produk.harga
                                  ).replace("Rp", "Rp ")}
                                </span>
                              )
                            ) : (
                              <span className="text-gray-500 text-sm">
                                Price not available
                              </span>
                            )}
                          </div>

                          {/* Quantity and Delete */}
                          <div className="flex items-center space-x-2 text-base md:text-lg mt-2">
                            <img
                              src={DeleteIcon}
                              alt="Hapus"
                              className="w-6 h-6 md:w-8 md:h-8 cursor-pointer"
                              onClick={() => handleRemoveItem(item.id)}
                            />
                            <button
                              onClick={() =>
                                handleChangeQuantity(item.id, jumlah - 1)
                              }
                              disabled={jumlah <= 1}
                              className="bg-black text-white w-8 h-8 flex items-center justify-center rounded hover:bg-gray-400 hover:text-black"
                            >
                              -
                            </button>
                            <span className="text-lg font-bold">{jumlah}</span>
                            <button
                              onClick={() =>
                                handleChangeQuantity(item.id, jumlah + 1)
                              }
                              className="bg-black text-white w-8 h-8 flex items-center justify-center rounded hover:bg-gray-400 hover:text-black"
                            >
                              +
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}

              <div className="text-right">
                <button
                  onClick={() => {
                    const fromDetail = location.state?.from || "/";
                    navigate(fromDetail);
                  }}
                  className="bg-black text-white text-sm md:text-base font-bold py-3 px-3 rounded mt-6 hover:bg-gray-400 hover:text-black"
                >
                  ADD ANOTHER ITEMS
                </button>
              </div>
            </div>

            <div className="w-full lg:w-1/3 bg-white shadow-lg rounded-lg p-4 md:p-6">
              <h3 className="text-xl md:text-2xl font-bold mb-4">
                Order Summary
              </h3>
              <p className="text-base md:text-lg">
                Subtotal: {formatRupiah(subtotal)}
              </p>

              <p className="text-base md:text-lg">
                Discount: {Number(totalDiscount).toFixed(0)}%
              </p>
              <p className="text-base md:text-lg">
                Total Weight: {totalWeight / 1000} kg
              </p>
              {/* <p className="text-base md:text-lg">Color: {color || "N/A"}</p> */}
              <p className="text-lg md:text-xl font-bold mt-4">
                Total: {formatRupiah(totalAfterDiscount)}
              </p>
              {/* {selectedItems.length > 0 &&
                (() => {
                  const selectedCartItems = cart.filter((item) =>
                    selectedItems.includes(item.id)
                  );
                  const preorderStatuses = selectedCartItems.map(
                    (item) => (item.produk || item.Produk)?.preorder
                  );
                  const hasPreorder = preorderStatuses.includes("Y");
                  const hasReadyStock = preorderStatuses.includes("N");

                  if (hasPreorder && hasReadyStock) {
                    return (
                      <span className="text-center text-sm md:text-base text-red-400 flex justify-center mt-2">
                        ⚠️ Order Contains Mixed Status Items. You cannot check
                        out with both pre-order and ready-stock products in the
                        same order. To continue, please remove one type and
                        place a separate order.
                      </span>
                    );
                  }
                  return null;
                })()} */}

              {isMixedCart && (
                <span className="text-center text-sm md:text-base text-red-400 flex justify-center mt-4">
                  ⚠️ Order Contains Mixed Status Items. You cannot check out
                  with both pre-order and ready-stock products in the same
                  order. Please remove one type and place a separate order.
                </span>
              )}

              <button
                onClick={handleCheckout}
                disabled={isMixedCart}
                className={`w-full text-lg md:text-xl font-bold py-3 rounded mt-6 
                ${
                  isMixedCart
                    ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                    : "bg-black text-white hover:bg-gray-400 hover:text-black"
                }`}
              >
                CHECK OUT
              </button>
              <p className="text-center text-xs md:text-sm text-gray-600 mt-2">
                By confirming this order, you agree to our{" "}
                <span
                  onClick={() => navigate("/term-page")}
                  className="cursor-pointer hover:underline"
                >
                  Terms and Conditions
                </span>{" "}
                and{" "}
                <span
                  onClick={() => navigate("/privacy-page")}
                  className="cursor-pointer hover:underline"
                >
                  Privacy Policy
                </span>
              </p>

              <div className="sm:flex-row flex-wrap justify-center gap-4 scale-90 md:scale-100 transition-transform duration-200 mt-4">
                {/* <div className="p-4 text-center rounded-lg flex-1 min-w-[250px] max-w-sm">
                  <div className="flex items-center justify-center gap-4">
                    <img
                      src={ClickPickup}
                      alt="Click & Pickup Icon"
                      className="w-10 h-10 md:w-14 md:h-14"
                    />
                    <div className="text-left">
                      <h6 className="text-base md:text-xl font-semibold">
                        Click & Pickup
                      </h6>
                      <p className="text-sm w-56">
                        Shop online and pick up in store
                      </p>
                    </div>
                  </div>
                </div> */}

                <div className="p-4 text-center rounded-lg flex-1 min-w-[250px] max-w-sm">
                  <div className="flex items-center justify-center gap-4">
                    <img
                      src={FreeShipping}
                      alt="Free Shipping Icon"
                      className="h-10 md:h-14"
                    />
                    <div className="text-left">
                      <h6 className="text-base md:text-xl font-semibold">
                        Free Shipping
                      </h6>
                      <p className="text-sm w-56">
                        Enjoy free delivery nationwide with no minimum spend
                      </p>
                    </div>
                  </div>
                </div>

                <div className="p-4 text-center rounded-lg flex-1 min-w-[250px] max-w-sm">
                  <div className="flex items-center justify-center gap-4">
                    <img
                      src={SameDayDelivery}
                      alt="Same Day Delivery Icon"
                      className="h-10 md:h-14"
                    />
                    <div className="text-left">
                      <h6 className="text-base md:text-xl font-semibold">
                        Same Day Delivery
                      </h6>
                      <p className="text-sm w-56">
                        Order online and have it delivered to your door that
                        same day
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="w-full py-18 px-4 md:px-20 text-center">
        <div>
          <h2 className="text-3xl md:text-4xl font-semibold mb-8">
            You may also like
          </h2>
          <Carousel
            responsive={responsive}
            infinite={true}
            autoPlay={true}
            autoPlaySpeed={3000}
            className="mt-5"
          >
            {products.map((product) => {
              const discountPercentage = product.diskon
                ? Math.round((product.diskon / product.harga[0]) * 100)
                : null;

              return (
                <div
                  key={product.id}
                  className="p-4 cursor-pointer relative bg-white rounded-lg hover:shadow-xl transition-shadow duration-300"
                  // onClick={() => handleCardClick(product.id)}
                  onClick={() => handleCardClick(product.nama_produk)}
                >
                  {Number(product.diskon) > 0 && (
                    <div className="absolute top-4 left-4 bg-red-500 text-white px-3 py-1 rounded text-sm font-bold">
                      {/* {product.diskon}% OFF */}
                      {Number(product.diskon).toFixed(0)}% OFF
                    </div>
                  )}

                  <img
                    src={product.image[0]}
                    alt={product.nama_produk}
                    className="w-full h-32 object-contain rounded-t-lg"
                  />

                  <h4 className="text-left text-lg md:text-md font-semibold mt-4">
                    {product.nama_produk}
                  </h4>

                  <div className="flex justify-between items-center mt-4">
                    {/* Product Colors */}
                    <div className="flex space-x-2">
                      {product.color &&
                        product.color.map((color, index) => (
                          <div
                            key={index}
                            className="flex flex-col items-center"
                          >
                            <div
                              className="w-6 h-6 rounded-full"
                              style={{ backgroundColor: color }}
                            ></div>
                          </div>
                        ))}
                    </div>

                    {/* Pricing */}
                    <div className="flex flex-col items-end">
                      {/* <p className="text-lg font-bold text-gray-800">
                        {formatRupiah(product.harga[0] - (product.diskon || 0))}
                      </p>
                      {product.diskon && (
                        <p className="text-sm text-gray-400 line-through">
                          {formatRupiah(product.harga[0])}
                        </p>
                      )} */}
                      {product.harga && (product.harga[0] || product.harga) ? (
                          Number(product.diskon) > 0 ? (
                            <>
                              <span className="text-red-500 font-bold text-sm md:text-lg">
                                {formatRupiah(
                                  (product.harga[0] || product.harga) -
                                    ((product.harga[0] || product.harga) *
                                      Number(product.diskon)) /
                                      100
                                ).replace("Rp", "Rp ")}
                              </span>
                              <span className="text-gray-400 line-through text-sm">
                                {formatRupiah(
                                  product.harga[0] || product.harga
                                ).replace("Rp", "Rp ")}
                              </span>
                            </>
                          ) : (
                            <span className="text-sm md:text-lg font-medium text-gray-700">
                              {formatRupiah(
                                product.harga[0] || product.harga
                              ).replace("Rp", "Rp ")}
                            </span>
                          )
                        ) : (
                          <span className="text-gray-500 text-sm">
                            Price not available
                          </span>
                        )}
                    </div>
                  </div>
                </div>
              );
            })}
          </Carousel>
        </div>
      </div>

      {/* Carousel for Brands */}
      <div className="mt-7 mb-14 bg-white rounded-lg shadow-lg p-4">
        {brands.length > 0 && (
          <Carousel
            responsive={responsive}
            infinite={true}
            autoPlay={true}
            autoPlaySpeed={3000}
          >
            {brands.map((brand, index) => (
              <img
                key={index}
                src={brand.image}
                alt={`Brand ${index}`}
                // onClick={() => handleImageClick(brand.id)}
                onClick={() => handleImageClick(brand.nama_brand, brand.id)}
                className="cursor-pointer w-full h-40 sm:h-48 md:h-56 lg:h-64 object-contain hover:scale-105 transition-transform duration-300"
              />
            ))}
          </Carousel>
        )}
      </div>

      {isModalOpen && (
        <ProductModal
          product={selectedProduct}
          onClose={() => setIsModalOpen(false)}
        />
      )}

      <Footer />
    </div>
  );
};

export default Cart;
